export const queries = {
  mobile: `(max-width: 600px)`
}